import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';

const mapTitlesTable = {
  1: {
    statusColumn: 'Status da entrevista',
    resultColumn: 'Resultado da entrevista',
    custonFilterInscriptionDate: 'Data de inscrição',
    custonFilterDate: 'Data de processamento',
    processingDateTitle: 'Processado',
  },
  2: {
    statusColumn: 'Status do questionário',
    resultColumn: 'Resultado do questionário',
    custonFilterInscriptionDate: 'Data de inscrição',
    custonFilterDate: 'Data de Conclusão',
    processingDateTitle: 'Conclusão',
  },
  3: {
    statusColumn: 'Status da entrevista',
    resultColumn: 'Resultado da entrevista',
    custonFilterInscriptionDate: 'Data de inscrição',
    custonFilterDate: 'Data de processamento',
    processingDateTitle: 'Processado',
  },
  4: {
    statusColumn: 'Status da entrevista',
    resultColumn: 'Resultado da entrevista',
    custonFilterInscriptionDate: 'Data de inscrição',
    custonFilterDate: 'Data de registro do resultado',
    processingDateTitle: 'Resultado',
  },
};

export function useConfigTable() {
  const { getQueryString } = Sebrae.useRouter();

  const [settingsTable, setSetingsTable] = React.useState({});

  React.useEffect(() => {
    const moduloId = getQueryString('modulo');
    setSetingsTable(mapTitlesTable[moduloId ?? 1]);
  }, [getQueryString]);

  return {
    settingsTable,
  };
}
